<template>
  <div class="select_file_box">
    <div style="margin-bottom:15px;">
      <el-radio-group v-model="file_radio" @change="switchChange">
        <el-radio-button label="contract_data">数据中心</el-radio-button>
        <el-radio-button label="task_result">任务结果文件</el-radio-button>
        <el-radio-button label="object_file">项目文件</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="file_radio == 'contract_data'" style="min-height:200px;">
      <div v-loading="is_my_data_loading">
        <TreeTable :personal_data="extend_json_data.personal_data" @updataSelected="updataSelected"></TreeTable>
      </div>
    </div>
    <div v-if="file_radio == 'task_result'" style="min-height:200px;">
      <div style="margin-top: 15px;">
        <span>任务列表：</span>
        <el-select :disabled="is_task_list_loading" v-model="task_select_id" placeholder="请选择" filterable
          @change="taskSelectChange">
          <el-option v-for="item in task_list" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="file_list_box">
        <el-tree :data="task_tree" :props="task_props" default-expand-all :expand-on-click-node="false">
          <template #default="{ node, data }">
            <div @click="taskNodeClick(node, data)">
              <div class="path_box">{{ node.label }}</div>
            </div>
          </template>
        </el-tree>

      </div>
    </div>

    <div v-if="file_radio == 'object_file'">
      <div style="margin: 10px">
        <el-select style="width: 100%" filterable v-model="project_id" @change="change_get_project_file()" clearable
          placeholder="请选择项目">
          <el-option v-for="item in project_list" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="margin: 0 10px;">
        <el-row style="background-color: #f7f7f7;">
          <el-col :span="10">
            <el-card style="margin: 10px; width: 97%" class="box-card" shadow="never">
              <span>目录结构：</span>
              <el-tree ref="tree" class="tree_box" :data="project_dir_tree" style="height: 200px; overflow-y: auto"
                :default-expand-all="true" highlight-current :props="defaultProps" @node-click="analysisClick">
                <template #default="{ node, data }">
                  <span class="custom-tree-node" @click="handleNodeClick(node)">
                    <img v-if="node.expanded" src="static/img/tree_open.svg" />
                    <img v-else src="static/img/tree_close.svg" />
                    {{ data.name }}
                  </span>
                </template>
              </el-tree>
            </el-card>
          </el-col>
          <el-col :span="14">
            <el-card style="margin: 10px; width: 97%" class="box-card" shadow="never">
              <span>文件：</span>
              <el-radio-group v-if="!Array.isArray(current_select_result)" v-model="current_select_result"
                style="width: 100%;height: 200px;overflow-y: auto;margin-left: 15px;">
                <template v-for="is of project_file_list">
                  <el-radio style="display: block; margin-top: 5px" v-if="is.file_name != 'metadata.tsv'" :label="input_type &&
                  ['int', 'Int'].indexOf(input_type) >= 0
                  ? is.id
                  : is.file_path
                  " :key="is.id">{{ is.file_name }}</el-radio>
                </template>
              </el-radio-group>
              <div v-else>
                <el-checkbox :indeterminate="is_Indeterminate" v-model="is_select_checkAll"
                  @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group :max="file_length" v-model="current_select_result"
                  style="width: 100%;height: 200px;overflow-y: auto;margin-left: 15px;"
                  @change="handleCheckedCitiesChange">
                  <template v-for="is of project_file_list">
                    <el-checkbox style="display: block; margin-top: 5px" v-if="is.file_name != 'metadata.tsv'" :label="input_type &&
                        ['int', 'Int'].indexOf(input_type) >= 0
                        ? is.id
                        : is.file_path
                        " :key="is.id">
                      {{ is.file_name }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="bottom_container">
      <div class="dir_path_box" :title="current_select_result">当前选择文件: {{
        showTextHandle(current_select_result) }}</div>
      <span class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 认</el-button>
      </span>
    </div>

  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { get_contract_data, get_project_list, get_project_dir, get_project_file, get_task_list, get_data_center_data, get_task_dir } from '@/api/index.js';
  import TreeTable from './TreeTable.vue';

  const emit = defineEmits(['saveinput'])
  const props = defineProps({
    file_dialog_data: {
      type: Object,
    },
    currentKey: {
      type: String,
    }
  });

  const input_type = ref('Array[String]');
  const extend_json_data = ref({
    "personal_data": {
      "is_use": true,
      "file_whitelist": []
    },
    "contract_data": {
      "is_use": false,
      "file_whitelist": []
    }
  });
  const defaultProps = ref({
    children: 'children',
    label: 'label'
  });
  const file_radio = ref('contract_data');
  const is_select_checkAll = ref(false);
  const is_Indeterminate = ref(true);
  const file_dialog = ref(null);
  const is_project_list = ref(false);//项目列表 loading
  const project_id = ref(null);//项目id
  const project_list = ref([]);//项目列表数据
  const project_file_list = ref([]);//项目文件列表数据
  const task_list = ref([]);//任务列表数据
  const is_task_list_loading = ref(false);//任务列表 loading
  const task_select_id = ref(null);//任务id
  const task_tree = ref(null);//任务树数据
  const task_props = ref({
    label: 'label',
    children: 'children'
  });//任务树属性

  const data_center_type = ref('my_contract_data');//数据中心类型
  const is_get_contract_data_loading = ref(false);//获取合同数据 loading
  const contract_data = ref(null);//合同数据

  const is_my_data_loading = ref(false);//获取我的数据 loading


  const project_dir_tree = ref([]);//项目目录树数据
  const current_select_result = ref(null);//当前选择结果



  const switchChange = function (val) {//数据源来源切换
    if (val == "contract_data") getMyData();
    if (val == "task_result") getTaskList();
    if (val == "object_file") getProjectList();
    const folderUpload = document.getElementById('folderUpload');
    if (folderUpload) {
      folderUpload.querySelector('input').webkitdirectory = true;//webkitdirectory属性兼容性处理
    }
  };

  const dataCenterChange = function (val) {//数据中心切换
    if (val == 'my_contract_data') getContractData();
    if (val == 'my_data') getMyData();
  };

  const showTextHandle = function (value) {//显示文字得处理
    if (value) {
      const routers = value.split('/');
      return routers[routers.length - 1]
    } else {
      return '';
    }
  };

  const getContractData = function () {//获取合同数据
    is_get_contract_data_loading.value = true;
    get_contract_data({}).then((result) => {
      let columns = ['project_name', 'file_name', 'contract_no_offline', 'inlet', 'name', 'type'], data = [];
      result.forEach((item, index) => {
        const { project_name, file_name, contract_no_offline } = item;
        const file_list = item.file_list;
        file_list.forEach((e, i) => {
          const { inlet, name, type } = e;
          data.push([project_name, file_name, contract_no_offline, inlet, name, type]);
        });
      });
      contract_data.value = { columns, data };
      is_get_contract_data_loading.value = false;
    }).catch((err) => {
      console.error(err);
      is_get_contract_data_loading.value = false;
    });
  };

  const getProjectList = function () { //获取项目
    is_project_list.value = true;
    get_project_list(null).then((result) => {

      console.log('获取项目列表', result);

      const projectId = result[0].id;

      console.log('第一个项目id', projectId);

      project_id.value = projectId;
      project_list.value = result || [];
      getProjectDir(projectId);
      is_project_list.value = false;
    }).catch((err) => {
      console.error(err);
      is_project_list.value = false;
    });
  };

  const getProjectDir = function (id) { //获取指定项目id的目录结构
    get_project_dir({ project_id: id }).then((result) => {
      project_dir_tree.value = result;
      if (result.length > 0) {
        const default_obj = result[0];
        getProjectFile(default_obj.project_id, default_obj.id);
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  const getProjectFile = function (project_id, folder_id) { //获取指定项目id中的文件信息
    get_project_file({ project_id, folder_id }).then((result) => {
      project_file_list.value = result;
    }).catch((err) => {
      console.error(err);
    });
  };

  const handleNodeClick = function (node) {//目录树点击事件
    const default_obj = node.data;
    getProjectFile(default_obj.project_id, default_obj.id);
  };

  const getTaskList = function () {//获取任务列表
    is_task_list_loading.value = true;
    get_task_list(null).then((result) => {
      const task_s = result.map((item) => {
        return { id: item.id, name: item.name };
      });
      task_list.value = task_s || [];
      is_task_list_loading.value = false;
    }).catch((err) => {
      console.error(err);
      is_task_list_loading.value = false;
    });
  };

  const taskSelectChange = function (val) {//任务列表选择事件
    task_select_id.value = val;
    getTaskDir(val, null);
  };

  const getMyData = function () {//获取我的数据
    get_data_center_data({ path: null }).then((result) => {
      console.log('获取我的数据', result);
    }).catch((err) => {
      console.error(err);
    });
  };

  const taskNodeClick = function (node, data) {//任务树点击事件
    current_select_result.value = node.data.dir;
    if (data.type !== "file") {
      node.loading = true;
      get_task_dir({ "id": task_select_id.value, "dir": node.data.dir }).then((result) => {
        if (!(data.children.length > 0)) {
          data.children = result.data;
        };
        node.loading = false;
      }).catch((err) => {
        node.loading = false;
      });
    };
  };

  const getTaskDir = function (id, dir_path) {//获取指定任务id的目录结构
    get_task_dir({ "id": id, "dir_path": dir_path }).then((result) => {
      task_tree.value = result.data;
    }).catch((err) => {
      console.error(err);
    });
  };

  const handleClose = function () {//关闭弹窗
    emit('saveinput', null);
  };

  const handleConfirm = function () {//确认选择
    emit('saveinput', current_select_result.value);
  };

  const updataSelected = function (val) { //更新当前选择结果
    current_select_result.value = val;
  };

  const change_get_project_file = function () { //切换项目时更新项目文件列表
    getProjectDir(project_id.value);
  };

  const handleCheckAllChange = function (val) { //全选按钮点击事件
    if (val) {
      let key = input_type.value && ['int', 'Int'].indexOf(input_type.value) >= 0 ? 'id' : 'dir_name';
      let list = [];
      fileData.value.forEach((item) => {
        if (item.name != 'metadata.tsv') { //排除metadata.tsv文件
          list.push(item[key]);
        }
      });
      current_select_result.value = list;
    } else {
      current_select_result.value = [];
    };
    is_Indeterminate.value = false;
  };

  const analysisClick = function (data) { //目录树点击事件

  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
    getContractData();
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  .file_list_box {
    margin-top: 15px;
    height: 200px;
    overflow-y: auto;
  }

  .path_box {
    width: 300px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .custom-tree-node img {
    vertical-align: middle;
  }

  .bottom_container {
    display: flex;
    margin-top: 15px;
  }

  .dir_path_box {
    flex: 1;
    font-size: 14px;
    color: #5e6d82;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 32px;
  }
</style>

<style>
  .select_file_box .el-radio-group {
    display: inline-block;
  }
</style>